import template from './advertInlineAddPage.html';
import controller from './advertInlineAddPage.controller';
import './advertInlineAddPage.scss';

let advertInlineAddPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default advertInlineAddPageComponent;
